/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { IndexDependencies } from './dependenciesIndexClass.generated.js';
import { compareNaturalDependencies } from './dependenciesCompareNatural.generated.js';
import { sizeDependencies } from './dependenciesSize.generated.js';
import { subsetDependencies } from './dependenciesSubset.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSetDistinct } from '../../factoriesAny.js';
export var setDistinctDependencies = {
  DenseMatrixDependencies,
  IndexDependencies,
  compareNaturalDependencies,
  sizeDependencies,
  subsetDependencies,
  typedDependencies,
  createSetDistinct
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSetDistinct.generated.js
// module id = 1469
// module chunks = 2